export default __webpack_public_path__ + "static/media/value_color.59ac91d1.svg";